// Versão em inglês do conteúdo do CMS (espelha backend/cms_en.py).
// A estrutura (itens, imagens, ícones, links, números) vem sempre do português;
// da versão em inglês só entram os textos. Texto EN vazio → mostra o PT.
export const SKIP_KEYS = new Set(["icone", "url", "demo_url", "destaque_imagem", "avatar", "modo", "numero", "ver_mais_url", "nome", "canal"]);

export function overlayText(pt, en, key) {
  if (SKIP_KEYS.has(key)) return pt;
  if (Array.isArray(pt)) {
    const e = Array.isArray(en) ? en : [];
    return pt.map((v, i) => overlayText(v, e[i], key));
  }
  if (pt && typeof pt === "object") {
    const e = en && typeof en === "object" ? en : {};
    return Object.fromEntries(Object.entries(pt).map(([k, v]) => [k, overlayText(v, e[k], k)]));
  }
  if (typeof pt === "string") return typeof en === "string" && en.trim() ? en : pt;
  return pt;
}

/** Seções da Home com os textos em inglês aplicados. */
export function mergeSecoes(secoes, en) {
  const dados = en?.secoes_dados || {};
  return (secoes || []).map((s) => (dados[s.id] ? { ...s, dados: overlayText(s.dados || {}, dados[s.id]) } : s));
}
